module.exports = "<button md-button class=\"wg-icon\" mdTooltip=\"{{ 'FOLLOW' | tooltip }} \" color='primary' *ngIf=\"item && (item.followedByMe == '0' || !item.followedByMe)\" (click)=\"toggleFollow($event)\">\n    <i class=\"material-icons icon follow\"></i>\n    </button>\n<button md-button class=\"wg-icon\" mdTooltip=\"{{ 'UNFOLLOW' | tooltip }}\" color='primary' *ngIf=\"item && item.followedByMe == '1'\" (click)=\"toggleFollow($event)\"> \n    <i class=\"material-icons icon unfollow\"></i>\n</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/my-discoveries/follow/follow.component.html
// module id = ./src/app/my-discoveries/follow/follow.component.html
// module chunks = main